import { motion } from "framer-motion";
import { Building2, Store, Factory, CalendarCheck, Sparkles } from "lucide-react";

const EASE = [0.76, 0, 0.24, 1];

const services = [
    {
        icon: Building2,
        title: "Office Cleaning",
        copy: "Scheduled cleaning that keeps workspaces tidy and ready for staff and visitors.",
        span: "md:col-span-4",
    },
    {
        icon: Store,
        title: "Retail & Food-Service Cleaning",
        copy: "Hygienic cleaning for stores and outlets, with food-safe standards for customer and food-contact areas.",
        span: "md:col-span-4",
    },
    {
        icon: Factory,
        title: "Industrial & Factory Cleaning",
        copy: "High-standard cleaning for manufacturing and production sites where hygiene is critical.",
        span: "md:col-span-4",
    },
    {
        icon: CalendarCheck,
        title: "Contract Cleaning",
        copy: "Ongoing scheduled cleaning managed to a fixed standard with regular reporting.",
        span: "md:col-span-6",
    },
    {
        icon: Sparkles,
        title: "Deep Cleaning",
        copy: "Periodic intensive cleaning that resets your premises to top condition.",
        span: "md:col-span-6",
    },
];

export default function Services() {
    return (
        <section id="services" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-testid="services-section">
            <motion.div
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: EASE }}
                className="mb-14 md:mb-20"
            >
                <p className="text-xs font-bold tracking-[0.25em] uppercase text-fern mb-4">What we do</p>
                <h2 className="font-serif font-medium tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl text-forest max-w-2xl text-balance">
                    Our services
                </h2>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                {services.map((s, i) => (
                    <motion.div
                        key={s.title}
                        data-testid={`service-card-${i}`}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.8, ease: EASE, delay: (i % 3) * 0.12 }}
                        className={`${s.span} group bg-background border border-edge rounded-3xl p-8 md:p-10 hover:shadow-sm transition-shadow duration-300`}
                    >
                        <s.icon
                            className="w-7 h-7 text-forest mb-6 group-hover:-translate-y-1 transition-transform duration-300"
                            strokeWidth={1.25}
                        />
                        <h3 className="font-serif text-2xl font-medium tracking-tight text-forest mb-3">{s.title}</h3>
                        <p className="text-sm font-light leading-relaxed text-fern">{s.copy}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
